import React from 'react'
import Headers from '../headers/Headers'
import Footers from '../footers/Footers'
import FooterCall from '../footers/FooterCall'

const WaterFeatureSpa = () => {
  return (
    <>
     <Headers/>
     <div>
        <h1>Water Features & Spa</h1>
        </div>
        <Footers/>
        <FooterCall/> 
    </>
  )
}

export default WaterFeatureSpa
